export enum BUSINESS_UNIT {
  OPENLANE = 'OPENLANE',
  TRADEREV = 'TRADEREV'
}

export default {};
